import {useCallback} from 'react';
import {call} from 'redux-saga/effects';

import {actions, useSagaCallback} from "../store/sagas";
import {defaultSettings} from "../store/settings";
import {apiPost, clearApiCredentials} from "./client";

const useLogout = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* () {
        try {
            yield call(apiPost, `/api/v2/logout`);
        } catch (error) {
            if (error.message !== 'invalid credentials') {
                throw error;
            }
        }
        yield call(clearApiCredentials);
        yield actions.settingsChanged(defaultSettings);
        yield actions.userChanged();
    }, []));
};

export default useLogout;
